// NutriSafrins Theme JS
document.addEventListener('DOMContentLoaded', function () {

  // ---- Mobile menu ----
  var header = document.getElementById('site-header');
  var toggle = document.getElementById('menu-toggle');
  if (header && toggle) {
    toggle.addEventListener('click', function () {
      var open = header.classList.toggle('menu-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      document.body.classList.toggle('no-scroll', open);
    });
    header.querySelectorAll('.nav a, .nav-cta').forEach(function (a) {
      a.addEventListener('click', function () {
        header.classList.remove('menu-open');
        document.body.classList.remove('no-scroll');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth > 900) {
        header.classList.remove('menu-open');
        document.body.classList.remove('no-scroll');
      }
    });
  }

  // ---- Buy forms: quantity + variant picker (no page reload on size change) ----
  document.querySelectorAll('[data-buy-form]').forEach(function (form) {
    var qty = form.querySelector('.qty-input');
    var minus = form.querySelector('.qty-minus');
    var plus = form.querySelector('.qty-plus');
    if (qty && minus && plus) {
      minus.addEventListener('click', function () {
        var v = parseInt(qty.value, 10) || 1;
        if (v > 1) qty.value = v - 1;
      });
      plus.addEventListener('click', function () {
        var v = parseInt(qty.value, 10) || 1;
        qty.value = v + 1;
      });
    }

    var section = form.closest('.product-section') || document;
    var priceEl = section.querySelector('[data-price]');
    var compareEl = section.querySelector('[data-compare]');
    var saveEl = section.querySelector('[data-save]');
    var addBtn = form.querySelector('[data-add-btn]');
    var radios = form.querySelectorAll('input[type="radio"][name="id"]');

    function syncVariant(radio, updateUrl) {
      if (!radio) return;
      if (priceEl) priceEl.textContent = radio.getAttribute('data-price') || '';
      var cmp = radio.getAttribute('data-compare') || '';
      if (compareEl) {
        compareEl.textContent = cmp;
        compareEl.style.display = cmp ? '' : 'none';
      }
      var save = radio.getAttribute('data-save') || '';
      if (saveEl) {
        saveEl.textContent = save;
        saveEl.style.display = save ? '' : 'none';
      }
      var available = radio.getAttribute('data-available') === 'true';
      if (addBtn) {
        addBtn.disabled = !available;
        addBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
      }
      form.querySelectorAll('.variant-pill').forEach(function (p) {
        p.classList.toggle('is-selected', p.contains(radio));
      });
      if (updateUrl && window.history && window.history.replaceState && /\/products\//.test(location.pathname)) {
        try {
          var u = new URL(location.href);
          u.searchParams.set('variant', radio.value);
          window.history.replaceState({}, '', u.toString());
        } catch (e) {}
      }
    }

    radios.forEach(function (r) {
      r.addEventListener('change', function () { syncVariant(r, true); });
      if (r.checked) syncVariant(r, false);
    });

    // Add-to-cart feedback
    form.addEventListener('submit', function () {
      if (addBtn) { addBtn.textContent = 'Adding…'; }
    });
  });

  // ---- Product thumbnails ----
  document.querySelectorAll('.product-thumbs').forEach(function (wrap) {
    var main = wrap.closest('.product-image-wrap').querySelector('.product-image');
    wrap.querySelectorAll('.product-thumb').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (main) main.src = btn.getAttribute('data-src');
        wrap.querySelectorAll('.product-thumb').forEach(function (b) { b.classList.remove('is-active'); });
        btn.classList.add('is-active');
      });
    });
  });

  // ---- Smooth scroll for in-page anchors ----
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var id = this.getAttribute('href');
      if (id.length < 2) return;
      var target = document.querySelector(id);
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });
});
